<template>
  <the-section :title="$t('ec-line009.shipping.title')">
    <template #subTitle>
      <el-button class="section__button" @click="toShippingPage">{{ $t('common.action.edit') }}</el-button>
    </template>
    <template #sub>
      <p class="mx-0 lg:mx-6 text-gray-950 text-base mt-2">
        {{ $t('ec-line009.shippingSubTitle') }}
      </p>
    </template>
    <el-row v-if="!isEmpty(data)" class="lg:flex">
      <el-row class="mb-2 lg:mr-3">
        <label class="text-body-01 required">{{ $t('ec-line009.shipping.subTitle') }}</label>
      </el-row>
      <el-row type="flex" justify="space-between" align="middle">
        <address-info-item
          :full-name="full_name"
          :postal-code="data.postal_code"
          :address="full_address"
          :building-name="data.addr03"
        ></address-info-item>
      </el-row>
    </el-row>
    <el-row v-else>
      {{ $t('ec-line009.content.noShippingAddress') }}
    </el-row>
  </the-section>
</template>

<script>
import isEmpty from 'lodash/isEmpty'
import TheSection from '@/components/my-page-partials/TheSection.vue'
import AddressInfoItem from '../AddressInfoItem.vue'

export default {
  components: { TheSection, AddressInfoItem },
  props: {
    data: { type: Object, default: () => {} },
  },
  computed: {
    full_name() {
      return this.Utils.helper.fullName(this.data.name01, this.data.name02)
    },
    full_address() {
      return this.Utils.helper.address(this.data.pref?.name, this.data.addr01, this.data.addr02)
    },
  },
  methods: {
    isEmpty,
    falsyToEmpty(item) {
      return item ?? ''
    },
    toShippingPage() {
      if (isEmpty(this.data)) {
        this.$router.push(this.$routePage.EC_LINE011_NEW)
      } else {
        // EC-LINE011で配送先の追加・更新後にEC-LINE027に遷移し、追加・更新後の配送先を選択状態にする機能追加に伴い、
        // 再度メニューから遷移する時はaddressUpsertのaddressIdを消してis_default: trueの配送先を表示するため
        this.$store.commit('addressUpsert/resetAddressId')
        this.$router.push(this.$routePage.EC_LINE027)
      }
    },
  },
}
</script>

<style></style>
